// extracted by mini-css-extract-plugin
export default {"logoLink":"Logo_logoLink__aHxOF"};